import React from "react";
import { Typography, Grid, Chip } from "@mui/material";
import { Link } from "react-router-dom/cjs/react-router-dom";
const MenuAdmin = () => {
  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={3}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Link to={`/productos-admin`}>
            <Chip
              label='Productos'
              sx={{ padding: 3, fontSize: "30px" }}
              icon={
                <svg
                  height='45px'
                  version='1.1'
                  id='Layer_1'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 512 512'
                  fill='#000000'
                >
                  <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                  <g
                    id='SVGRepo_tracerCarrier'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></g>
                  <g id='SVGRepo_iconCarrier'>
                    {" "}
                    <g transform='translate(1 1)'>
                      {" "}
                      <path
                        style={{ fill: "#FD9808" }}
                        d='M444.44,121.88h-25.6c30.72,0,55.467,24.747,55.467,55.467v263.68 c0,30.72-24.747,55.467-55.467,55.467h25.6c30.72,0,55.467-24.747,55.467-55.467V178.2C500.76,147.48,475.16,121.88,444.44,121.88'
                      ></path>{" "}
                      <path
                        style={{ fill: "#fb9828" }}
                        d='M7.533,404.333V233.667c0,23.893,46.08,42.667,102.4,42.667s102.4-18.773,102.4-42.667v170.667 c0,23.893-46.08,42.667-102.4,42.667S7.533,428.227,7.533,404.333'
                      ></path>{" "}
                      <path
                        style={{ fill: "#54C9FD" }}
                        d='M7.533,387.267h34.133V319H7.533V387.267z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#1CD759" }}
                        d='M348.867,11.8v25.6v8.533V88.6H434.2V45.933h42.667V11.8C476.867,11.8,348.867,11.8,348.867,11.8z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#15A143" }}
                        d='M476.867,45.933h25.6V11.8h-25.6V45.933z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#fb9828" }}
                        d='M323.267,122.733H434.2V88.6H323.267V122.733z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#FD9808" }}
                        d='M434.2,122.733h25.6V88.6h-25.6V122.733z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#FFFFFF" }}
                        d='M33.133,404.333V261.827c-16.213-7.68-25.6-17.067-25.6-28.16v170.667 c0,23.893,46.08,42.667,102.4,42.667c4.267,0,8.533,0,12.8,0C72.387,444.44,33.133,426.52,33.133,404.333'
                      ></path>{" "}
                      <path
                        style={{ fill: "#33A9F8" }}
                        d='M41.667,387.267h17.067V319H41.667V387.267z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#54C9FD" }}
                        d='M127,387.267h59.733V319H127V387.267z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#33A9F8" }}
                        d='M186.733,387.267h25.6V319h-25.6V387.267z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#FCC309" }}
                        d='M7.533,233.667v-51.2c0,23.893,46.08,42.667,102.4,42.667s102.4-18.773,102.4-42.667v51.2 c0,23.893-46.08,42.667-102.4,42.667S7.533,257.56,7.533,233.667'
                      ></path>{" "}
                      <path
                        style={{ fill: "#FFFFFF" }}
                        d='M33.133,233.667v-23.04c-16.213-7.68-25.6-17.067-25.6-28.16v51.2 c0,23.893,3.413,34.133,59.733,34.133c4.267,0,12.8,0,17.067,0C28.013,287.427,33.133,255.853,33.133,233.667'
                      ></path>{" "}
                      <path
                        style={{ fill: "#fb9828" }}
                        d='M212.333,182.467c0,23.893-46.08,42.667-102.4,42.667s-102.4-18.773-102.4-42.667 s46.08-42.667,102.4-42.667S212.333,159.427,212.333,182.467'
                      ></path>{" "}
                      <path
                        style={{ fill: "#FFFFFF" }}
                        d='M33.133,182.467c0-21.333,39.253-39.253,89.6-42.667c-4.267,0-8.533,0-12.8,0 c-56.32,0-102.4,18.773-102.4,42.667s46.08,42.667,102.4,42.667c4.267,0-29.867,0-25.6,0 C33.987,222.573,33.133,204.653,33.133,182.467'
                      ></path>{" "}
                      <path
                        style={{ fill: "#fb9828" }}
                        d='M421.4,498.2h-84.48c-30.72,0-55.467-24.747-55.467-55.467v-263.68 c0-30.72,24.747-55.467,55.467-55.467h84.48c30.72,0,55.467,24.747,55.467,55.467v263.68C476.867,473.453,452.12,498.2,421.4,498.2 '
                      ></path>{" "}
                      <path
                        style={{ fill: "#54C9FD" }}
                        d='M280.6,404.333h128V216.6h-128V404.333z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#33A9F8" }}
                        d='M408.6,404.333h25.6V216.6h-25.6V404.333z'
                      ></path>{" "}
                      <path d='M447,506.733H336.067c-35.84,0-64-29.013-64-64v-263.68c0-35.84,29.013-64,64-64h110.08c35.84,0,64,29.013,64,64v263.68 C511,477.72,481.987,506.733,447,506.733z M336.067,131.267c-26.453,0-46.933,21.333-46.933,46.933v263.68 c0,26.453,21.333,46.933,46.933,46.933h110.08c26.453,0,46.933-21.333,46.933-46.933V179.053c0-26.453-21.333-46.933-46.933-46.933 h-110.08V131.267z'></path>{" "}
                      <path d='M468.333,131.267h-153.6v-51.2h153.6V131.267z M331.8,114.2h119.467V97.133H331.8V114.2z'></path>{" "}
                      <path d='M442.733,97.133h-102.4V3.267H511v51.2h-68.267V97.133z M357.4,80.067h68.267V37.4h68.267V20.333H357.4V80.067z'></path>{" "}
                      <path d='M442.733,412.867H272.067v-204.8h170.667V412.867z M289.133,395.8h136.533V225.133H289.133V395.8z'></path>{" "}
                      <path d='M331.8,276.333h-51.2c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h51.2 c5.12,0,8.533,3.413,8.533,8.533C340.333,272.92,336.92,276.333,331.8,276.333z'></path>{" "}
                      <path d='M374.467,319H280.6c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h93.867 c5.12,0,8.533,3.413,8.533,8.533C383,315.587,379.587,319,374.467,319z'></path>{" "}
                      <path d='M212.333,361.667h-51.2c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533h51.2c5.12,0,8.533,3.413,8.533,8.533 S217.453,361.667,212.333,361.667z'></path>{" "}
                      <path d='M374.467,361.667H280.6c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533h93.867c5.12,0,8.533,3.413,8.533,8.533 S379.587,361.667,374.467,361.667z'></path>{" "}
                      <path d='M109.933,455.533C46.787,455.533-1,433.347-1,404.333V233.667c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533 c0,16.213,40.107,34.133,93.867,34.133s93.867-17.92,93.867-34.133c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533 v170.667C220.867,433.347,173.08,455.533,109.933,455.533z M16.067,261.827v142.507c0,16.213,40.107,34.133,93.867,34.133 s93.867-17.92,93.867-34.133V261.827c-19.627,14.507-53.76,23.04-93.867,23.04S35.693,276.333,16.067,261.827z'></path>{" "}
                      <path d='M109.933,284.867C46.787,284.867-1,262.68-1,233.667v-51.2c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533 c0,16.213,40.107,34.133,93.867,34.133s93.867-17.92,93.867-34.133c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533 v51.2C220.867,262.68,173.08,284.867,109.933,284.867z M16.067,210.627v23.04c0,16.213,40.107,34.133,93.867,34.133 s93.867-17.92,93.867-34.133v-23.04c-19.627,14.507-53.76,23.04-93.867,23.04S35.693,225.133,16.067,210.627z'></path>{" "}
                      <path d='M109.933,233.667C46.787,233.667-1,211.48-1,182.467s47.787-51.2,110.933-51.2s110.933,22.187,110.933,51.2 S173.08,233.667,109.933,233.667z M109.933,148.333c-53.76,0-93.867,17.92-93.867,34.133S56.173,216.6,109.933,216.6 s93.867-17.92,93.867-34.133S163.693,148.333,109.933,148.333z'></path>{" "}
                      <path d='M212.333,395.8H127c-5.12,0-8.533-3.413-8.533-8.533V319c0-5.12,3.413-8.533,8.533-8.533h85.333 c5.12,0,8.533,3.413,8.533,8.533v68.267C220.867,392.387,217.453,395.8,212.333,395.8z M135.533,378.733H203.8v-51.2h-68.267 V378.733z'></path>{" "}
                      <path d='M58.733,395.8h-51.2c-5.12,0-8.533-3.413-8.533-8.533V319c0-5.12,3.413-8.533,8.533-8.533h51.2 c5.12,0,8.533,3.413,8.533,8.533v68.267C67.267,392.387,63.853,395.8,58.733,395.8z M16.067,378.733H50.2v-51.2H16.067V378.733z'></path>{" "}
                    </g>{" "}
                  </g>
                </svg>
              }
            />
          </Link>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={3}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Link to={`/categorias-admin`}>
            <Chip
              label='Categorias'
              sx={{ padding: 3, fontSize: "30px" }}
              icon={
                <svg
                  height='45px'
                  version='1.1'
                  id='Layer_1'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 512 512'
                  fill='#000000'
                >
                  <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                  <g
                    id='SVGRepo_tracerCarrier'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></g>
                  <g id='SVGRepo_iconCarrier'>
                    {" "}
                    <g>
                      {" "}
                      <path
                        style={{ fill: "#2D527C" }}
                        d='M102.374,479.485C45.926,479.485,0,433.56,0,377.11c0-56.448,45.926-102.374,102.374-102.374 c36.125,0,69.958,19.362,88.293,50.532c4.075,6.929,1.762,15.849-5.165,19.923c-6.929,4.077-15.848,1.762-19.923-5.165 c-13.129-22.318-37.348-36.182-63.206-36.182c-40.4,0-73.267,32.867-73.267,73.267s32.867,73.268,73.267,73.268 c25.404,0,48.634-12.873,62.142-34.431c4.269-6.813,13.25-8.873,20.059-4.608c6.811,4.269,8.873,13.25,4.606,20.059 C170.318,461.509,137.866,479.485,102.374,479.485z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#2D527C" }}
                        d='M497.446,359.756H254.324c-8.038,0-14.554-6.517-14.554-14.554s6.516-14.554,14.554-14.554h243.122 c8.037,0,14.554,6.517,14.554,14.554S505.483,359.756,497.446,359.756z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#2D527C" }}
                        d='M406.276,423.573H254.324c-8.038,0-14.554-6.517-14.554-14.554s6.516-14.554,14.554-14.554h151.951 c8.037,0,14.554,6.517,14.554,14.554S414.314,423.573,406.276,423.573z'
                      ></path>{" "}
                    </g>{" "}
                    <circle
                      style={{ fill: "#CEE8FA" }}
                      cx='102.371'
                      cy='134.884'
                      r='87.817'
                    ></circle>{" "}
                    <g>
                      {" "}
                      <path
                        style={{ fill: "#2D527C" }}
                        d='M102.374,237.263C45.924,237.263,0,191.338,0,134.89C0,78.44,45.924,32.515,102.374,32.515 S204.748,78.44,204.748,134.89C204.75,191.338,158.824,237.263,102.374,237.263z M102.374,61.622 c-40.4,0-73.267,32.868-73.267,73.268s32.867,73.267,73.267,73.267s73.267-32.867,73.267-73.267S142.774,61.622,102.374,61.622z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#2D527C" }}
                        d='M497.446,117.535H254.324c-8.038,0-14.554-6.517-14.554-14.554s6.516-14.554,14.554-14.554h243.122 c8.037,0,14.554,6.517,14.554,14.554S505.483,117.535,497.446,117.535z'
                      ></path>{" "}
                      <path
                        style={{ fill: "#2D527C" }}
                        d='M406.276,181.35H254.324c-8.038,0-14.554-6.517-14.554-14.554s6.516-14.554,14.554-14.554h151.951 c8.037,0,14.554,6.517,14.554,14.554S414.314,181.35,406.276,181.35z'
                      ></path>{" "}
                    </g>{" "}
                  </g>
                </svg>
              }
            />
          </Link>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={3}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Link to={`/ventas-admin`}>
            <Chip
              label='Ventas'
              sx={{ padding: 3, fontSize: "30px" }}
              icon={
                <svg
                  viewBox='0 0 64 64'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='#000000'
                  width='45px'
                >
                  <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                  <g
                    id='SVGRepo_tracerCarrier'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></g>
                  <g id='SVGRepo_iconCarrier'>
                    {" "}
                    <g id='a'></g>{" "}
                    <g id='b'>
                      {" "}
                      <path
                        d='M30.02,5c-8.18,0-14.81,6.63-14.81,14.81,0,5.56,3.12,10.66,8.07,13.19l8.05,6.25,10.43-10.41c1.99-2.59,3.07-5.76,3.07-9.03,0-8.18-6.63-14.81-14.81-14.81Z'
                        fill='#f2d865'
                        fillRule='evenodd'
                      ></path>{" "}
                      <path
                        d='M30.02,5c-.56,0-1.12,.03-1.66,.1,7.4,.83,13.15,7.1,13.15,14.71,0,3.27-1.08,6.44-3.07,9.03l-8.97,8.95,1.87,1.45,10.43-10.41c1.99-2.59,3.07-5.76,3.07-9.03,0-8.18-6.63-14.81-14.81-14.81h0Z'
                        fill='#f2d865'
                        fillRule='evenodd'
                      ></path>{" "}
                      <path
                        d='M14.44,33c-2.4,0-4.33,1.93-4.33,4.33s1.93,4.33,4.33,4.33v8.67c-2.4,0-4.33,1.94-4.33,4.34s1.93,4.33,4.33,4.33h20.3c1,0,1.93-.34,2.66-.91l-1.92-18.93-6.9-6.17H14.44Z'
                        fill='#f2d865'
                        fillRule='evenodd'
                      ></path>{" "}
                      <path
                        d='M26.04,50.33H14.45c-2.4,0-4.34-1.93-4.34-4.33s1.93-4.33,4.34-4.33h9.94l1.65,8.67Z'
                        fill='#e9c03d'
                        fillRule='evenodd'
                      ></path>{" "}
                      <circle
                        cx='39.08'
                        cy='43.39'
                        fill='#f5e680'
                        r='14.81'
                        transform='translate(-15.15 21.73) rotate(-26.22)'
                      ></circle>{" "}
                      <circle
                        cx='39.08'
                        cy='43.39'
                        fill='#ebb680'
                        r='8.12'
                      ></circle>{" "}
                      <circle
                        cx='30.02'
                        cy='19.81'
                        fill='#ebb680'
                        r='8.12'
                        transform='translate(8.18 48.38) rotate(-86.02)'
                      ></circle>{" "}
                      <path
                        d='M39.08,28.58c-.67,0-1.33,.05-1.99,.14,7.32,1.01,12.78,7.27,12.78,14.67,0,7.4-5.47,13.66-12.8,14.66,.67,.09,1.34,.14,2.01,.14,8.18,0,14.81-6.63,14.81-14.81s-6.63-14.81-14.81-14.81Z'
                        fill='#f2d865'
                        fillRule='evenodd'
                      ></path>{" "}
                      <path
                        d='M39.08,35.27c-.46,0-.9,.04-1.34,.11,3.85,.64,6.79,3.98,6.79,8.01s-2.94,7.37-6.79,8.01c.43,.07,.88,.11,1.34,.11,4.49,0,8.12-3.64,8.12-8.12s-3.63-8.12-8.12-8.12Z'
                        fill='#e6a361'
                        fillRule='evenodd'
                      ></path>{" "}
                      <path
                        d='M30.02,11.69c-.44,0-.87,.04-1.29,.1,3.87,.62,6.83,3.97,6.83,8.02s-2.96,7.4-6.83,8.02c.42,.07,.85,.1,1.29,.1,4.49,0,8.12-3.63,8.12-8.12s-3.64-8.12-8.12-8.12Z'
                        fill='#e6a361'
                        fillRule='evenodd'
                      ></path>{" "}
                      <path d='M43.33,28.23c1.59-2.52,2.5-5.44,2.5-8.42,0-8.72-7.09-15.81-15.81-15.81s-15.81,7.09-15.81,15.81c0,4.81,2.17,9.22,5.79,12.19h-5.56c-2.94,0-5.33,2.39-5.33,5.33,0,1.79,.89,3.37,2.25,4.33-1.36,.97-2.25,2.55-2.25,4.33s.89,3.37,2.25,4.33c-1.35,.97-2.25,2.54-2.25,4.33,0,2.94,2.39,5.33,5.33,5.33h20.3c1.07,0,2.08-.35,2.95-.94,.46,.04,.91,.14,1.38,.14,8.72,0,15.81-7.09,15.81-15.81,0-7.24-4.91-13.29-11.56-15.15Zm-27.12-8.42c0-7.61,6.19-13.81,13.81-13.81s13.81,6.19,13.81,13.81c0,2.86-.93,5.66-2.59,7.99-.71-.1-1.42-.22-2.16-.22-4.23,0-8.07,1.7-10.91,4.42h-4.62c-4.53-2.4-7.34-7.04-7.34-12.19Zm-5.1,17.52c0-1.84,1.5-3.33,3.33-3.33h12c-1.44,1.94-2.46,4.19-2.89,6.67H14.44c-1.84,0-3.33-1.5-3.33-3.33Zm3.33,12c-1.84,0-3.33-1.5-3.33-3.33s1.5-3.33,3.33-3.33h8.91c-.01,.25-.07,.48-.07,.72,0,2.1,.43,4.11,1.18,5.94H14.44Zm0,8.67c-1.84,0-3.33-1.5-3.33-3.33s1.5-3.33,3.33-3.33h11.05c1.74,2.97,4.38,5.35,7.6,6.67H14.44Zm24.64-.8c-7.61,0-13.81-6.19-13.81-13.81s6.15-13.81,13.81-13.81,13.81,6.19,13.81,13.81-6.19,13.81-13.81,13.81Z'></path>{" "}
                      <path d='M39.08,34.27c-5.03,0-9.12,4.09-9.12,9.12s4.09,9.12,9.12,9.12,9.12-4.09,9.12-9.12-4.09-9.12-9.12-9.12Zm0,16.24c-3.93,0-7.12-3.2-7.12-7.12s3.2-7.12,7.12-7.12,7.12,3.19,7.12,7.12-3.19,7.12-7.12,7.12Z'></path>{" "}
                      <path d='M30.02,28.93c5.03,0,9.12-4.09,9.12-9.12s-4.09-9.12-9.12-9.12-9.12,4.09-9.12,9.12,4.09,9.12,9.12,9.12Zm0-16.24c3.93,0,7.12,3.2,7.12,7.12s-3.2,7.12-7.12,7.12-7.12-3.19-7.12-7.12,3.19-7.12,7.12-7.12Z'></path>{" "}
                      <path d='M30.02,20.81c.4,0,.72,.32,.72,.72s-.32,.72-.72,.72c-.19,0-.37-.08-.51-.21-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41c.27,.27,.58,.46,.92,.6v.28c0,.55,.45,1,1,1s1-.45,1-1v-.29c1.01-.4,1.72-1.37,1.72-2.52,0-1.5-1.22-2.72-2.72-2.72-.4,0-.72-.32-.72-.72s.32-.72,.72-.72c.19,0,.38,.08,.51,.21,.39,.39,1.02,.39,1.41,0s.39-1.02,0-1.41c-.27-.27-.58-.46-.92-.6v-.28c0-.55-.45-1-1-1s-1,.45-1,1v.29c-1,.4-1.72,1.37-1.72,2.52,0,1.5,1.22,2.72,2.72,2.72Z'></path>{" "}
                      <path d='M39.08,42.39c-.4,0-.72-.32-.72-.72s.32-.72,.72-.72c.19,0,.37,.07,.51,.21,.39,.39,1.02,.39,1.41,0s.39-1.02,0-1.41c-.27-.27-.58-.47-.92-.6v-.28c0-.55-.45-1-1-1s-1,.45-1,1v.29c-1,.4-1.72,1.37-1.72,2.52,0,1.5,1.22,2.72,2.72,2.72,.4,0,.72,.32,.72,.72s-.32,.72-.72,.72c-.19,0-.37-.08-.51-.21-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41c.27,.27,.58,.46,.92,.6v.28c0,.55,.45,1,1,1s1-.45,1-1v-.29c1-.4,1.72-1.37,1.72-2.52,0-1.5-1.22-2.72-2.72-2.72Z'></path>{" "}
                      <circle cx='39.08' cy='31.92' r='1'></circle>{" "}
                      <circle cx='39.08' cy='54.85' r='1'></circle>{" "}
                      <circle cx='50.55' cy='43.39' r='1'></circle>{" "}
                      <circle cx='27.62' cy='43.39' r='1'></circle>{" "}
                      <path d='M47.9,35.99c.39-.39,.39-1.03,0-1.41-.39-.39-1.03-.39-1.41,0-.39,.39-.39,1.03,0,1.41s1.03,.39,1.41,0Z'></path>{" "}
                      <path d='M30.27,50.79c-.39,.39-.39,1.03,0,1.41,.39,.39,1.03,.39,1.41,0,.39-.39,.39-1.03,0-1.41-.39-.39-1.03-.39-1.41,0Z'></path>{" "}
                      <path d='M47.19,50.49c-.27,0-.52,.11-.71,.29-.39,.39-.39,1.03,0,1.41,.19,.19,.44,.29,.71,.29s.52-.11,.71-.29c.39-.39,.39-1.03,0-1.41-.19-.19-.44-.29-.71-.29Z'></path>{" "}
                      <path d='M30.98,36.28c.26,0,.52-.11,.71-.29,.39-.39,.39-1.03,0-1.41-.19-.19-.44-.29-.71-.29s-.52,.11-.71,.29c-.39,.39-.39,1.03,0,1.41,.19,.19,.44,.29,.71,.29Z'></path>{" "}
                      <circle cx='30.02' cy='8.34' r='1'></circle>{" "}
                      <circle cx='41.48' cy='19.81' r='1'></circle>{" "}
                      <circle cx='18.55' cy='19.81' r='1'></circle>{" "}
                      <path d='M38.83,12.41c.39-.39,.39-1.03,0-1.41-.39-.39-1.03-.39-1.41,0-.39,.39-.39,1.03,0,1.41s1.03,.39,1.41,0Z'></path>{" "}
                      <path d='M21.2,27.21c-.39,.39-.39,1.03,0,1.41,.39,.39,1.03,.39,1.41,0,.39-.39,.39-1.03,0-1.41-.39-.39-1.03-.39-1.41,0Z'></path>{" "}
                      <path d='M21.91,12.7c.27,0,.52-.11,.71-.29,.39-.39,.39-1.03,0-1.41-.19-.19-.44-.29-.71-.29s-.52,.11-.71,.29c-.39,.39-.39,1.03,0,1.41,.19,.19,.44,.29,.71,.29Z'></path>{" "}
                    </g>{" "}
                    <g id='c'></g> <g id='d'></g> <g id='e'></g> <g id='f'></g>{" "}
                    <g id='g'></g> <g id='h'></g> <g id='i'></g> <g id='j'></g>{" "}
                    <g id='k'></g> <g id='l'></g> <g id='m'></g> <g id='n'></g>{" "}
                    <g id='o'></g> <g id='p'></g> <g id='q'></g> <g id='r'></g>{" "}
                    <g id='s'></g> <g id='t'></g> <g id='u'></g> <g id='v'></g>{" "}
                    <g id='w'></g> <g id='x'></g> <g id='y'></g> <g id='a`'></g>{" "}
                    <g id='aa'></g> <g id='ab'></g> <g id='ac'></g>{" "}
                    <g id='ad'></g> <g id='ae'></g> <g id='af'></g>{" "}
                    <g id='ag'></g> <g id='ah'></g> <g id='ai'></g>{" "}
                    <g id='aj'></g> <g id='ak'></g> <g id='al'></g>{" "}
                    <g id='am'></g> <g id='an'></g> <g id='ao'></g>{" "}
                    <g id='ap'></g> <g id='aq'></g> <g id='ar'></g>{" "}
                    <g id='as'></g> <g id='at'></g> <g id='au'></g>{" "}
                    <g id='av'></g> <g id='aw'></g> <g id='ax'></g>{" "}
                  </g>
                </svg>
              }
            />
          </Link>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          xl={3}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Link to={`/Reportes-Admin`}>
            <Chip
              label='Reportes'
              sx={{ padding: 3, fontSize: "30px" }}
              icon={
                <svg
                  viewBox='0 0 1024 1024'
                  class='icon'
                  version='1.1'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='#000000'
                  width='45px'
                >
                  <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                  <g
                    id='SVGRepo_tracerCarrier'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></g>
                  <g id='SVGRepo_iconCarrier'>
                    <path
                      d='M858.5 933.3h-24v-16h16v3.9h8v12.1z m-40 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0H165v-18.5h16v10.5h-2.5v8z m680-28.1h-16v-16h16v16zM181 898.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 866.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 834.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 802.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 770.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 738.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 706.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 674.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 642.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 610.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 578.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 546.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 514.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 482.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 450.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 418.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 386.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 354.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 322.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 290.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 258.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 226.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 194.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 162.8h-16v-16h16v16z m677.5-25.6h-16v-16h16v16zM181 130.8h-16v-16h16v16z m677.5-25.6h-16v-8.4h0.4v-8h15.6v16.4z m-31.6-0.5h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0h-16v-16h16v16z m-32 0H173v-5.9h-8V88.7h21.9v16z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M261.7 193.2h500.2v228.9H261.7z'
                      fill='#EBB866'
                    ></path>
                    <path
                      d='M769.8 430.2H253.7v-245h516.2v245z m-500.1-16h484.2v-213H269.7v213z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M261.7 496.3h112.4v129.4H261.7z'
                      fill='#55B7A8'
                    ></path>
                    <path
                      d='M382.1 633.7H253.7V488.3h128.4v145.4z m-112.4-16h96.4V504.3h-96.4v113.4z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M455.5 496.3h112.4v129.4H455.5z'
                      fill='#55B7A8'
                    ></path>
                    <path
                      d='M576 633.7H447.5V488.3H576v145.4z m-112.5-16H560V504.3h-96.4v113.4z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M261.7 709.9h112.4v129.4H261.7z'
                      fill='#55B7A8'
                    ></path>
                    <path
                      d='M382.1 847.3H253.7V701.9h128.4v145.4z m-112.4-16h96.4V717.9h-96.4v113.4z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M455.5 709.9h112.4v129.4H455.5z'
                      fill='#55B7A8'
                    ></path>
                    <path
                      d='M576 847.3H447.5V701.9H576v145.4z m-112.5-16H560V717.9h-96.4v113.4z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M649.4 496.3h112.4v342.9H649.4z'
                      fill='#55B7A8'
                    ></path>
                    <path
                      d='M769.8 847.3H641.4v-359h128.4v359z m-112.4-16h96.4v-327h-96.4v327zM261.7 256.3h78.5v16h-78.5zM261.7 333h139.7v16H261.7z'
                      fill='#0A0408'
                    ></path>
                    <path d='M147.3 71h51.4v51.4h-51.4z' fill='#DC444A'></path>
                    <path
                      d='M206.7 130.5h-67.4V63h67.4v67.5z m-51.4-16h35.4V79h-35.4v35.5z'
                      fill='#0A0408'
                    ></path>
                    <path d='M824.8 71h51.4v51.4h-51.4z' fill='#DC444A'></path>
                    <path
                      d='M884.2 130.5h-67.4V63h67.4v67.5z m-51.4-16h35.4V79h-35.4v35.5z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M147.3 899.6h51.4V951h-51.4z'
                      fill='#DC444A'
                    ></path>
                    <path
                      d='M206.7 959h-67.4v-67.4h67.4V959z m-51.4-16h35.4v-35.4h-35.4V943z'
                      fill='#0A0408'
                    ></path>
                    <path
                      d='M824.8 899.6h51.4V951h-51.4z'
                      fill='#DC444A'
                    ></path>
                    <path
                      d='M884.2 959h-67.4v-67.4h67.4V959z m-51.4-16h35.4v-35.4h-35.4V943z'
                      fill='#0A0408'
                    ></path>
                  </g>
                </svg>
              }
            />
          </Link>
        </Grid>
      </Grid>
    </>
  );
};

export default MenuAdmin;
